import { RADashboardCardId } from '@/constants/ReportDashboard/cards-enums'
import { CardTitleLookup } from '@/constants/ReportDashboard/cards-metadata'
import { useTheme } from '@/contexts/RADashboardThemeContext/hooks'
import AddIcon from '@mui/icons-material/Add'
import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material'
import React from 'react'

type DashboardCardOptionItemProps = {
  cardId: RADashboardCardId
  disabled: boolean
  inUse: boolean
  tooltipPlacement: 'left' | 'right'
  onClick: () => void
}

const DashboardCardOptionItem: React.FC<DashboardCardOptionItemProps> = ({
  cardId,
  disabled,
  inUse,
  tooltipPlacement,
  onClick,
}) => {
  const theme = useTheme()

  const itemStyle = {
    borderRadius: '8px',
    border: `1px solid ${theme.border}`,
    backgroundColor: theme.cardBackground,
    mb: 0.75,
    '&.Mui-disabled': {
      opacity: 0.4,
      border: `1px solid ${theme.border}`,
      backgroundColor: theme.cardBackground,
    },
  }

  return (
    <Tooltip
      title={inUse ? 'Card already in use' : ''}
      placement={tooltipPlacement}
      arrow
      disableHoverListener={!inUse}
    >
      {/* span required for Tooltip to work on a disabled element */}
      <span>
        <ListItemButton disabled={disabled} onClick={onClick} sx={itemStyle}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <AddIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={CardTitleLookup[cardId]}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItemButton>
      </span>
    </Tooltip>
  )
}

export default DashboardCardOptionItem
